import API from "../../../../global/api";


export const requestAddFiles = () => {
    return {
        type: "REQUEST_ADD_FILES",
    };
};
export const successAddFiles = (data) => {
    return {
        type: "SUCCESS_ADD_FILES",
        payload: data,
    };
};
export const errorAddFiles = () => {
    return {
        type: "ERROR_ADD_FILES",
    };
};
export const uploadFilesApi = (data) => {
    return (dispatch) => {
        const formData = new FormData();
        // formData.append("image", get(data, 'image'));
        formData.append("image", data.image)
        dispatch(requestAddFiles());
        API.post(`/files/image`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((res) => {
            let getData = res.data;
            dispatch(successAddFiles(getData));
        }).catch((error) => {
            dispatch(errorAddFiles());
        })
    }
};